import React from "react";
import { Box, IconButton, LinearProgress, useTheme } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CustomTypography from "../../../../../../views/components/common/form/CustomTypography";

/** Compact pager + top progress line shared by POD revenue tables. */
export const PodRevenueTableProgress = ({ loading }: { loading: boolean }) => (
  <Box sx={{ height: 2 }}>
    {loading ? <LinearProgress sx={{ height: 2 }} /> : null}
  </Box>
);

const PodRevenuePager = ({
  page,
  pages,
  loading,
  onPage,
  summary,
}: {
  page: number;
  pages: number;
  loading: boolean;
  onPage: (page: number) => void;
  summary?: React.ReactNode;
}) => {
  const colors = useTheme().palette.customColors;
  const total = Math.max(pages, 1);
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={1}
      px={1.5}
      py={1}
      sx={{ borderTop: `1px solid ${colors.lightGray}`, bgcolor: colors.white }}
    >
      <CustomTypography variant="heading8" color={colors.mutedSlateText}>
        {summary}
      </CustomTypography>
      <Box display="flex" alignItems="center" gap={0.5}>
        <IconButton
          size="small"
          aria-label="Previous page"
          disabled={page <= 1 || loading}
          onClick={() => onPage(page - 1)}
        >
          <ChevronLeftIcon fontSize="small" />
        </IconButton>
        <CustomTypography
          variant="heading8"
          fontWeight={600}
          color={colors.navyText}
          sx={{ minWidth: 64, textAlign: "center" }}
        >
          {page} / {total}
        </CustomTypography>
        <IconButton
          size="small"
          aria-label="Next page"
          disabled={page >= total || loading}
          onClick={() => onPage(page + 1)}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default PodRevenuePager;
